module.exports = __webpack_public_path__ + "img/enjoy.0f695e1f.png";